import React from "react";
import { ABOUT_FEATURES, BRAND } from "../mock/mock";
import { Check } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 bg-viimii-2">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center">
        {/* Image */}
        <div className="reveal relative">
          <div className="relative rounded-3xl overflow-hidden border hairline">
            <video
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              className="w-full h-[520px] object-cover"
              aria-label="VIIMII Studio video"
            >
              <source src="/studio/about-video.mp4" type="video/mp4" />
              <source src="/studio/about-video.webm" type="video/webm" />
            </video>
          </div>
          <div className="absolute -bottom-7 -right-4 md:right-8 bg-viimii border hairline rounded-2xl px-7 py-5 text-center shadow-2xl">
            <div className="font-display text-4xl gold-gradient-text">Est.</div>
            <div className="font-display text-2xl text-cream">{BRAND.est}</div>
            <div className="text-[11px] text-cream/50 tracking-widest uppercase mt-1">Studio</div>
          </div>
        </div>

        {/* Copy */}
        <div className="reveal">
          <p className="section-line text-gold mb-4">About {BRAND.name}</p>
          <h2 className="font-display text-4xl md:text-5xl leading-tight font-medium">
            Expert nail & hair artistry,
            <span className="gold-gradient-text italic"> crafted with precision.</span>
          </h2>
          <p className="mt-6 text-cream/70 leading-relaxed">
            At {BRAND.name}, our team of skilled artists brings years of professional
            experience in luxury nail design, eyelash extensions and premium hair spa
            care. Every service is crafted with creativity and attention to detail -
            a refined experience built around sophistication, comfort and flawless results.
          </p>

          <div className="mt-9 grid sm:grid-cols-2 gap-x-8 gap-y-7">
            {ABOUT_FEATURES.map((f) => (
              <div key={f.title} className="flex gap-3">
                <span className="mt-1 w-7 h-7 shrink-0 rounded-full grid place-items-center" style={{ background: "rgba(201,161,90,0.15)" }}>
                  <Check size={14} className="text-gold" style={{ color: "var(--viimii-gold)" }} />
                </span>
                <div>
                  <h3 className="font-display text-xl text-cream">{f.title}</h3>
                  <p className="text-sm text-cream/60 mt-1 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
